import {
  DoryMessageType,
  DoryServiceType,
  DoryStreamingHeader,
  DoryStreamingMessage,
} from '../../abstract/StreamingMessages';

function getNewsHeader(messageType: DoryMessageType): DoryStreamingHeader {
  return {
    service: DoryServiceType.NEWS,
    messageType,
    version: 'v1',
  };
}

type NewsRequestPayload = {
  fids: string[];
  timezone?: string;
  history?: string;
  fromnumber?: number;
  tonumber?: number;
  filter?: string;
};

type NewsResponsePayloadRaw = {
  fids: string[];
  value: [Array<string | string[]>];
};
type NewsResponsePayload = {
  fids: string[];
  news: {
    [fid: string]: string | string[];
  }[];
};

export { getNewsHeader, NewsRequestPayload, NewsResponsePayload };

//#region Subscribe
type NewsSubscribeHeader = {
  channelId?: string;
} & DoryStreamingHeader;

type NewsSubscribeRequest = {
  header: NewsSubscribeHeader;
  payload: NewsRequestPayload[];
} & DoryStreamingMessage;

type NewsSubscribeResponse = {
  header: NewsSubscribeHeader;
  payload: {
    status: number;
    message: string;
  };
} & DoryStreamingMessage;

function getNewsSubscribeRequest(
  channelId: string,
  payload: NewsRequestPayload[]
): NewsSubscribeRequest {
  return {
    header: {
      ...getNewsHeader(DoryMessageType.SUBSCRIBE),
      channelId,
    },
    payload,
  };
}

export {
  NewsSubscribeHeader,
  NewsSubscribeRequest,
  NewsSubscribeResponse,
  getNewsSubscribeRequest,
};
//#endregion

//#region Unsubscribe
type NewsUnsubscribeHeader = {
  channelId: string;
} & DoryStreamingHeader;

type NewsUnsubscribeRequest = {
  header: NewsUnsubscribeHeader;
} & DoryStreamingMessage;

type NewsUnsubscribeResponse = {
  header: NewsUnsubscribeHeader;
  payload: {
    status: number;
    message: string;
  };
} & DoryStreamingMessage;

function getNewsUnsubscribeRequest(channelId: string): NewsUnsubscribeRequest {
  return {
    header: {
      ...getNewsHeader(DoryMessageType.UNSUBSCRIBE),
      channelId,
    },
    payload: {},
  };
}

export {
  NewsUnsubscribeHeader,
  NewsUnsubscribeRequest,
  NewsUnsubscribeResponse,
  getNewsUnsubscribeRequest,
};
//#endregion

//#region Add
type NewsAddHeader = {
  channelId: string;
} & DoryStreamingHeader;

type NewsAddResponseRaw = {
  header: NewsAddHeader;
  payload: NewsResponsePayloadRaw[];
} & DoryStreamingMessage;
type NewsAddResponse = {
  header: NewsAddHeader;
  payload: NewsResponsePayload;
} & DoryStreamingMessage;

export { NewsAddHeader, NewsAddResponse, NewsAddResponseRaw };
//#endregion

//#region Change
type NewsChangeHeader = {
  channelId: string;
} & DoryStreamingHeader;

type NewsChangeResponseRaw = {
  header: NewsAddHeader;
  payload: NewsResponsePayloadRaw[];
} & DoryStreamingMessage;
type NewsChangeResponse = {
  header: NewsChangeHeader;
  payload: NewsResponsePayload;
} & DoryStreamingMessage;

export { NewsChangeHeader, NewsChangeResponse, NewsChangeResponseRaw };
//#endregion

//#region Snapshot
type NewsSnapshotHeader = {
  channelId: string;
} & DoryStreamingHeader;

type NewsSnapshotResponseRaw = {
  header: NewsAddHeader;
  payload: NewsResponsePayloadRaw[];
} & DoryStreamingMessage;
type NewsSnapshotResponse = {
  header: NewsSnapshotHeader;
  payload: NewsResponsePayload;
} & DoryStreamingMessage;

export { NewsSnapshotHeader, NewsSnapshotResponse, NewsSnapshotResponseRaw };
//#endregion

//#region Delete
type NewsDeleteHeader = {
  channelId: string;
} & DoryStreamingHeader;

type NewsDeleteResponseRaw = {
  header: NewsAddHeader;
  payload: NewsResponsePayloadRaw[];
} & DoryStreamingMessage;
type NewsDeleteResponse = {
  header: NewsDeleteHeader;
  payload: NewsResponsePayload;
} & DoryStreamingMessage;

export { NewsDeleteHeader, NewsDeleteResponse, NewsDeleteResponseRaw };
//#endregion
